import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeBlog = () => {
  const [BlogTopUser, setBlogTopUser] = useState([]);
  const [BlogUser, setBlogUser] = useState([]);
  const navigate = useNavigate();

  //   Blog top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getblogtop");
      setBlogTopUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getblog");
      setBlogUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteblog/${userId}`);

      setBlogUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Blog");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {BlogTopUser.map((user) => {
            return (
              <div>
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Blog-header-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p>{user.para}</p>
              </div>
            );
          })}
          <Link to="/Blog-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-1">Image</th>
                  <th className="col-lg-2">Date</th>
                  <th className="col-lg-2">Title</th>
                  <th className="col-lg-4">Description</th>
                  <th className="col-lg-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {BlogUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        {" "}
                        <img
                          src={user.blogimage}
                          alt="Blog"
                          style={{ width: "150px", height: "100px" }}
                        />
                      </td>
                      <td>{new Date(user.date).toLocaleDateString()}</td>
                      <td>{user.title}</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{ __html: user.description }}
                        ></p>
                      </td>
                      <td>
                        <Link to={`/Blog-view/` + user.id}>
                          <i
                            title="View"
                            className="fa-regular fa-eye action-btn"
                            style={{ color: "blue" }}
                          ></i>
                        </Link>
                        <Link to={`/Blog-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const BlogAdd = () => {
  const [BlogData, setBlogData] = useState({
    title: "",
    date: "",
    description: "",
    blogimage: null,
  });

  const [previewImage, setPreviewImage] = useState("");
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setBlogData((prev) => ({ ...prev, [name]: value }));
  };

  const imageHandler = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // Validate type
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // Validate size
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // Optional: Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width > 1050 || img.height > 700) {
          toast.error("Image dimensions should not exceed 1050x700.");
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setBlogData((prev) => ({ ...prev, blogimage: file }));
        setPreviewImage(objectUrl); // Show preview
      };
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (
      !BlogData.title ||
      !BlogData.date ||
      !BlogData.description ||
      !BlogData.blogimage
    ) {
      toast.error("All fields, including an image, are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", BlogData.title);
      formData.append("date", BlogData.date);
      formData.append("description", BlogData.description);
      formData.append("blogimage", BlogData.blogimage);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createblog", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/Blog"); // Redirect after success
    } catch (error) {
      console.error("Error adding Blog:", error);
      toast.error("Failed to add Blog!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/Blog">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Blog Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="blogimage">Upload Blog Image</label>
                <input
                  type="file"
                  id="blogimage"
                  name="blogimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "70%",
                      height: "350px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto",
                    }}
                  />
                )}
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="date">Date</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={BlogData.date}
                  id="date"
                  name="date"
                  placeholder="Enter Date e.g(2025/04/08)"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={BlogData.title}
                  id="title"
                  name="title"
                  placeholder="Enter Title"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description">Description</label>
                <textarea
                  onChange={inputHandler}
                  value={BlogData.description}
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  rows="4"
                ></textarea>
              </div>

              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeBlogEdit = () => {
  const [Bloguser, setBlogUser] = useState({
    title: "",
    date: "",
    description: "",
    blogimage: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) =>
          window.CKEDITOR.instances[instance].destroy(true)
        );
      }
    };
  }, []);

  // Fetch existing data
  const fetchBlogData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneblog/${id}`
      );
      if (response.data.success) {
        setBlogUser(response.data.data);
        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Blog data!", error);
      toast.error("Failed to load Blog data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) fetchBlogData();
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Bloguser.description || "");
    }
  }, [Bloguser.description, editorLoaded]);

  // Set preview image if already available
  useEffect(() => {
    if (Bloguser.blogimage && typeof Bloguser.blogimage === "string") {
      setPreviewImage(Bloguser.blogimage);
    }
  }, [Bloguser.blogimage]);

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setBlogUser({ ...Bloguser, [name]: value });
  };

  // Handle image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;

      img.onload = () => {
        const { width, height } = img;

        // Example check (adjust if needed)
        if (width > 1050 || height > 700) {
          toast.error("Image dimensions should not exceed 1050x700.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }

        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", Bloguser.title);
    const formattedDate = new Date(Bloguser.date)
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");
    formData.append("date", formattedDate);
    formData.append("description", window.CKEDITOR.instances.editor.getData());
    if (selectedImage) {
      formData.append("blogimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateblog/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Blog");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the Blog:", error);
      toast.error("Failed to update Blog.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Blog">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="blogimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  />
                )}
              </div>

              <div className="form-group">
                <br />
                <label>Date</label>
                <input
                  type="text"
                  value={new Date(Bloguser.date).toLocaleDateString()}
                  onChange={changeHandler}
                  className="form-control"
                  name="date"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={Bloguser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Blog">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomeBlogView = () => {
  const [BlogUser, setBlogUser] = useState({
    title: "",
    date: "",
    description: "",
    blogimage: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const BlogData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneblog/${id}`
        );
        setBlogUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    BlogData();
  }, [id]);

  return (
    <div className="container-fluid admin-view">
      <div className="row arpi">
        <div className="col-lg-3 col-md-3 col-sm-12"></div>

        <div className="col-lg-7 col-md-7 col-sm-12 view-sec">
          <Link to="/Blog" className="back-btn">
            <i className="fa-solid fa-arrow-left"></i> Back
          </Link>
          <br />
          <br />

          <h4>
            {BlogUser.title}{" "}
            <Link to={`/Blog-edit/` + BlogUser.id}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Link>
          </h4>
          <h6>{BlogUser.date}</h6>
          <br />
          <p dangerouslySetInnerHTML={{ __html: BlogUser.description }}></p>
          <br />
          <img
            src={BlogUser.blogimage}
            alt="Blog"
            style={{ width: "100%", height: "500px" }}
          />
        </div>
      </div>
    </div>
  );
};

export const BlogHeaderEdit = () => {
  const [Bloguser, setBlogUser] = useState({
    heading: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setBlogUser({ ...Bloguser, [name]: value });
    // console.log(user);
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneblogtop/${id}`
        );
        // console.log(response.data);
        setBlogUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      heading: Bloguser.heading,
      para: Bloguser.para,
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateblogtop/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setBlogUser(formData);
        toast.success("Data updated successfully!");
        navigate("/Blog");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/Blog">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Bloguser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  type="text"
                  value={Bloguser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  rows={4}
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Blog">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
